export const state = {
    items: [],
}